import React from 'react';
import { Link } from 'gatsby';
import { AssetRenderer } from '~helpers';
import AssetContainer from './AssetContainer';

var Asset = function Asset(_ref) {
  var assetPath = _ref.assetPath,
      assetHeight = _ref.assetHeight,
      path = _ref.path;

  if (!assetPath) {
    return null;
  }

  var renderAsset = /*#__PURE__*/React.createElement(AssetRenderer, {
    assetPath: assetPath,
    assetHeight: assetHeight
  });
  var renderItem = path ? /*#__PURE__*/React.createElement(Link, {
    to: path
  }, renderAsset) : renderAsset;
  return /*#__PURE__*/React.createElement(AssetContainer, null, renderItem);
};

Asset.defaultProps = {
  assetPath: undefined,
  assetHeight: undefined,
  path: undefined
};
export default Asset;